import {css} from 'styled-components';
import {palette} from "styled-theme";

export const TableStyled = css`
  /* stylelint-disable no-descending-specificity */
  .sortable-helper {
    opacity: 0.5;
  }
  
  /**
   * Table
   **/
  .ant-table-wrapper {
    &.hide-row-expand-icon {
      .ant-table-row-expand-icon {
        display: none;
      }
    }

    tr.total-row {
      background: white !important;

      td.ant-table-cell.subsection-col {
        background: white !important;
      }


      &:hover, td, td:hover {
        background: white !important;
      }
    }
    
    tr.ant-table-row.heading-row:hover > td {
      background: white !important;
    }
    
    .ant-table-row {
      td.subsection-col {
        &:hover {
          background: white !important;
        }
      }

      td.report-heading-col {
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
      }

      td.report-spacer-col {
        padding: 12px !important;
      }

      td.report-normal-col,
      td.report-type-total-col {
        &:first-child {
          padding-left: 22px !important;
        }
      }

      td.report-type-total-col {
        font-weight: bold;
        text-transform: uppercase;
      }

      td.report-category-total-col {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
  
  form.input-form {
    .item-table {
      tr {
        &.error {
          background: #ffccc7;

          &:hover td {
            background: #ffccc7 !important;
          }
        }

        td {
          vertical-align: top;

          /* added v4 version */
          .ant-legacy-form-item {
            padding-bottom: 0;
            margin: 0 -4px;

            textarea {
              margin-bottom: 0;
            }

            .product-id-select {
              /* max-width: 296px; */
              margin-bottom: 4px;
            }

            .account-id-select {
              width: 102px;
            }

            .tax-code-id-select {
              width: 87px;
            }

            .quantity-input {
              margin-bottom: 4px;
              text-align: right;


            }

            .unit-price-input,
            .amount-input,
            .discount-input,
            .balance-input {
              text-align: right;
            }
          }

          .ant-form-item {
            padding-bottom: 0;
            margin: 0 -4px;

            textarea {
              margin-bottom: 0;
            }

            .product-id-select {
              /* max-width: 296px; */
              margin-bottom: 4px;
            }

            .account-id-select {
              width: 102px;
            }

            .tax-code-id-select {
              width: 87px;
            }

            .quantity-input {
              margin-bottom: 4px;
              text-align: right;

              .ant-input-wrapper.ant-input-group {
                .ant-input {
                  padding-right: 4px !important;
                }
              }
            }

            .unit-price-input,
            .amount-input,
            .discount-input,
            .balance-input {
              text-align: right;
            }
          }

          .location-tag {
            max-width: 100%;
            margin-right: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .item-add-col {
      padding-top: 8px;
      padding-bottom: 8px;
      margin-bottom: 3px;
    }

    .summary-table-col {
      margin-top: -1px;
    }

     /* added v4 version */
    .ant-row.ant-legacy-form-item {
      &.no-bottom-margin {
        margin-bottom: 0;
      }

      &.pack {
        margin-bottom: 0;

        textarea.ant-input {
          margin-bottom: 0;
        }
      }
    }

    .ant-row.ant-form-item {
      &.no-bottom-margin {
        margin-bottom: 0;
      }

      &.pack {
        margin-bottom: 0;

        textarea.ant-input {
          margin-bottom: 0;
        }
      }
    }

    h2.subheading {
      margin-top: 12px;
      margin-bottom: 8px;
      font-size: 18px;
      font-weight: 400;
      border-bottom: 1px solid ${palette('border', 0)};
    }
  }
  
  .ant-table-row.bundle-row {
    background-color: #f5feff;
  }
  
  th.ant-table-cell:last-child {
    .resizable-title-handle {
      right: 0;
    }
  }

`;
